import { Component, OnInit, EventEmitter, Input, Output, AfterViewInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators, Form } from '@angular/forms';
import { MediaObserver, MediaChange } from '@angular/flex-layout';

import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

import { environment } from '../../../environments/environment';
import { ErrorHandler, HandleError } from '../../services/error-handler.service';
import { QuickPayPaymentService } from '../../services/quickpay-payment.service';
import { ReferenceService } from '../../services/reference.service';
import { CompanyService } from '../../services/company.service';      // 10/26/2021 RA
import { CompanyInformation } from '../../models/company';            // 10/26/2021 RA
import { PayoffAmount} from '../../models/reference';

import { QuickPayPaymentSelectType, QuickPayPaymentSelected } from '../quick-pay-payment-note-list/quick-pay-payment-note-list.component';
import { OpenNotesQuickPayPaymentInfoListItem, OpenNotesQuickPayPaymentInfoListGroupFooter } from 'src/app/models/quickpay';


@Component({
  selector: 'app-quick-pay-payment-amount',
  templateUrl: './quick-pay-payment-amount.component.html',
  styleUrls: ['./quick-pay-payment-amount.component.scss']
})
export class QuickPayPaymentAmountComponent implements OnInit {
  private _paymentSelected: QuickPayPaymentSelected = {
    quickpaypaymentSelectType: null,
    selectedId: null,
    selectedData: []
  };

  @Input() displayTitle = false;

  @Input() displayNotices = false;

  @Input()
  set quickpaypaymentSelected(quickpaypaymentSelected: QuickPayPaymentSelected) {
    this._paymentSelected = quickpaypaymentSelected || {
      quickpaypaymentSelectType: null,
      selectedId: null,
      selectedData: []
    };

    if (this._paymentSelected.selectedData.length > 1) {
      this.openNotesQuickPayPaymentInfoListWithFooters = this._paymentService.addOpenNotesQuickPayPaymentInfoListFooters(
        this._paymentSelected.selectedData
      );
    } else {
      this.openNotesQuickPayPaymentInfoListWithFooters = this._paymentSelected.selectedData;
    }
    this.dataUpdated();
    //if (this._paymentSelected.selectedId != null) {
      //this.getPayoffAmount(this._paymentSelected.selectedId);
      //this.totalAmountDueValue += this.payoffAmountDueValue.payoffAmount;
    //}
  }
  get quickpaypaymentSelected(): QuickPayPaymentSelected {
    return this._paymentSelected;
  }

  @Output() dataComplete = new EventEmitter<any>();
  @Output() selected = new EventEmitter<number>();

  // Have to use the following ElementDisplayStyle variables and ngStyle to show/hide table elements
  // This because the table paginator will not attach correctly otherwise - this is a work around for a known issue
  private _hideElementDisplayStyle = 'none';
  private _showElementDisplayStyle = 'inline';
  private _showElementDisplayStyleIE = 'inline-block';

  private _handleError: HandleError;
  private _logging = environment.logging;
  private companyCode: string = null;                 // 10/26/2021
  private payoffAmount = 0.00;

  isBrowserIE = /msie\s|trident\//i.test(window.navigator.userAgent);

  openNotesQuickPayPaymentInfoListWithFooters: (OpenNotesQuickPayPaymentInfoListItem | OpenNotesQuickPayPaymentInfoListGroupFooter)[] = [];

  // DataTable
  tableDisplayedColumns = [
    'noteId',
    'nextPaymentDueDate',
    'totalAmountDue'
  ];

  tableDataSource = new MatTableDataSource<OpenNotesQuickPayPaymentInfoListItem | OpenNotesQuickPayPaymentInfoListGroupFooter>(
    this.openNotesQuickPayPaymentInfoListWithFooters
  );

  tableDisplayStyle: string = this._hideElementDisplayStyle;
  tableDisplayStyleIE: string = this._hideElementDisplayStyle;
  quickpaypaymentSelectedDataFound = false;
  recordCount = 0;

  quickpaypaymentAmountForm: UntypedFormGroup;
  selectedPaymentOption = new UntypedFormControl();
  customPaymentAmount = new UntypedFormControl();

  customPaymentAmountValue = 0;
  minimumAmountDueValue = 0.01;
  maximumAmountDueValue = 0;
  totalAmountDueValue = 0;

  // 09/24/2024 RA
  payoffAmountDueValue: PayoffAmount
  getPayoffAmountComplete = false;
  showPayoffAmountSpinner = false;

  customPaymentAmountValueString = '';
  totalAmountDueValueString = '0.00';

  companyInformation: CompanyInformation;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _errorHandler: ErrorHandler,
    private _paymentService: QuickPayPaymentService,
    public media: MediaObserver,
    private _companyService: CompanyService,      // 10/26/2021 RA
    private _referenceService: ReferenceService
  ) {
    this._handleError = _errorHandler.createHandleError('QuickPayPaymentAmountComponent');
  }

  public newPayoffAmount(): PayoffAmount {
    const newPayoffAmount: PayoffAmount = {
      note_id: null,
      payoffAmount: null
    };
    return newPayoffAmount;
  }

  ngOnInit() {
    this.quickpaypaymentSelectedDataFound = true;
    this.tableDisplayStyle = this.quickpaypaymentSelectedDataFound? this._showElementDisplayStyle : this._hideElementDisplayStyle;
    this.tableDisplayStyleIE = this.quickpaypaymentSelectedDataFound ? this._showElementDisplayStyleIE : this._hideElementDisplayStyle;
  }

  dataUpdated(): void {
    this.getPayoffAmountComplete = false;
    this.customPaymentAmountValue = 0;
    this.maximumAmountDueValue = 0;
    this.totalAmountDueValue = 0;

    this.companyInformation = this._companyService.getNewCompanyInformation();      // 10/26/2021 RA
    this.companyCode =  this._companyService.getCompanyCode();                      // 10/26/2021 RA
    this.payoffAmountDueValue = this.newPayoffAmount();

    this.customPaymentAmountValueString = '';
    this.totalAmountDueValueString = '0.00';

    for (const item of this._paymentSelected.selectedData) {
      this.customPaymentAmountValue += item.minimumAmountDue;
      this.maximumAmountDueValue += item.totalAmountDue;
      this.totalAmountDueValue += item.totalAmountDue;
    }

    if (this._paymentSelected.selectedId != null) {
      this.getPayoffAmount(this._paymentSelected.selectedId);
      this.maximumAmountDueValue += this.payoffAmountDueValue.payoffAmount;
    }

    this.customPaymentAmountValue = Number(this.customPaymentAmountValue.toFixed(2));
    this.maximumAmountDueValue = Number(this.maximumAmountDueValue.toFixed(2));
    this.totalAmountDueValue = Number(this.totalAmountDueValue.toFixed(2));

    // this.customPaymentAmountValueString = this.customPaymentAmountValue.toFixed(2);
      this.totalAmountDueValueString = this.totalAmountDueValue.toFixed(2);

    this.createForm();

    this.recordCount = this._paymentSelected.selectedData.length;
    this.tableDataSource = new MatTableDataSource<OpenNotesQuickPayPaymentInfoListItem | OpenNotesQuickPayPaymentInfoListGroupFooter>(
      this.openNotesQuickPayPaymentInfoListWithFooters
    );
    this.quickpaypaymentSelectedDataFound = this._paymentSelected.selectedData.length > 0;
    this.tableDisplayStyle = this.quickpaypaymentSelectedDataFound ? this._showElementDisplayStyle : this._hideElementDisplayStyle;
    this.tableDisplayStyleIE = this.quickpaypaymentSelectedDataFound? this._showElementDisplayStyleIE : this._hideElementDisplayStyle;

    this.dataComplete.emit(true);
  }

  createForm(): void {
    this.quickpaypaymentAmountForm = this._formBuilder.group({});
    this.quickpaypaymentAmountForm.addControl('selectedPaymentOption', this.selectedPaymentOption);
    this.quickpaypaymentAmountForm.addControl('customPaymentAmount', this.customPaymentAmount);
    this.quickpaypaymentAmountForm.setValue({
      selectedPaymentOption: 'TOTAL',
      customPaymentAmount: this.customPaymentAmountValueString
    });

    this.selectedPaymentOptionChanged(this.selectedPaymentOption.value);

    // Set Default Value Change Subscriptions
    this.quickpaypaymentAmountForm.get('selectedPaymentOption').valueChanges.subscribe(val => {
      this.selectedPaymentOptionChanged(val);
    });
  }

  selectedPaymentOptionChanged(newSelectedPaymentOptionValue) {
    if (newSelectedPaymentOptionValue === 'TOTAL') {
      this.quickpaypaymentAmountForm.get('customPaymentAmount').clearValidators();
      this.quickpaypaymentAmountForm.get('customPaymentAmount').setValue(this.customPaymentAmountValueString);
      this.quickpaypaymentAmountForm.get('customPaymentAmount').updateValueAndValidity();
    } else if (newSelectedPaymentOptionValue === 'CUSTOM') {
      this.quickpaypaymentAmountForm.get('customPaymentAmount').clearValidators();
      this.quickpaypaymentAmountForm
        .get('customPaymentAmount')
        .setValidators([Validators.required, Validators.min(this.minimumAmountDueValue), Validators.max(this.maximumAmountDueValue)]);
      this.quickpaypaymentAmountForm.get('customPaymentAmount').updateValueAndValidity();
    }
  }

  setQuickPayPaymentAmount(): void {
    if (this.quickpaypaymentAmountForm.get('selectedPaymentOption').value === 'TOTAL') {
      this.selected.emit(this.totalAmountDueValue);
    } else if (this.quickpaypaymentAmountForm.get('selectedPaymentOption').value === 'CUSTOM') {
      const customPaymentAmount = Number(this.quickpaypaymentAmountForm.get('customPaymentAmount').value);
      this.selected.emit(customPaymentAmount);
    }
  }

  // 09/24/2024 RA
  getPayoffAmount(_note_id: number) : void {
    this.showPayoffAmountSpinner = true;
    this.getPayoffAmountComplete = false;

    this._referenceService.getPayoffAmnt(_note_id).subscribe(
      resultArray => {
        if (this._logging.serviceCallTraceLog) {
          console.log('QuickPayPaymentFormComponent.getQuickPayPayoffAmount :: resultArray.length= ' + resultArray);
        }
        if (this._logging.serviceDataTraceLog) {
          console.log('QuickPayPaymentFormComponent.getQuickPayPayoffAmount :: resultArray = ' + JSON.stringify(resultArray));
        }
        this.payoffAmountDueValue = resultArray;
        this.maximumAmountDueValue = this.payoffAmountDueValue.payoffAmount;
        this.getPayoffAmountComplete = true;
      },
      error => this._handleError('getPayoffAmount', error)
    );
  }

  isGroupFooter(index, item): boolean {
    return item.isGroupFooter;
  }

  onRadioButtonClick(radioValue: string) {
    this.quickpaypaymentAmountForm.get('selectedPaymentOption').setValue(radioValue);
  }

  // 10/26/2021 - Get Company Code
  CompanyCode_Check(): boolean {
    for (const companyLookup of environment.companyCode.legaltext ) {
      if (companyLookup.companyCode === this.companyCode ) {
        return true;
      }
    }
    return false;
  }

  getToolTip(element: string): string {
    let toolTip: string;
    switch (element.toUpperCase().trim()) {
      case 'TOTALAMOUNT': {
        toolTip =
          'Total Amount Due includes any past due balances including late and NSF fees + the upcoming payment due within the next 30 days. Login to your account or contact our Customer Service Department via the "Contact Us" link above for your payoff amount.';
        break;
      }
      default: {
        toolTip = 'No ToolTip message has been defined for ' + element;
        break;
      }
    }
    return toolTip;
  }
}
